import cn from "classnames"

import { getParticipantStatus } from "@utils/peopleUtils"

import ParticipantIcon from "./ParticipantIcon"

import "./index.scss"

// People's Activity restructure (2026-07-05): each row now optionally carries a compact
// `activityFlow` (what THIS person did, most-recent-first -- Content/Participants/index.jsx
// builds it) and an optional `rightSlot` (the self row's inline attendance control, replacing
// the removed standalone "Your Status" block). `rightSlot` clicks stop propagation so setting
// status doesn't also open the participant-details modal underneath it.
const ParticipantItem = ({
  participant,
  hideStatus,
  className,
  onClick,
  activityFlow,
  rightSlot,
}) => {
  return (
    <li
      className={cn("people-participant-item", className, {
        "people-participant-item-self": !!rightSlot,
      })}
      data-testid="teeup-detail-participant-row"
      data-participant-id={participant.id}
      data-is-self={!!rightSlot}
      onClick={() => onClick && onClick(participant)}>
      <ParticipantIcon
        avatar={participant.avatar}
        status={getParticipantStatus(participant.status)}
        isLarge
        hideStatus={hideStatus}
        isOrganizer={participant.isOrganiser}
        defaultAvatar={participant?.name || participant?.username}
      />

      <div className="people-participant-body">
        <div className="people-participant-info">
          <h4>{participant.name}</h4>
          {participant.username && <span>@{participant.username}</span>}
        </div>

        {activityFlow?.length > 0 && (
          <ul
            className="people-participant-flow"
            data-testid="teeup-detail-participant-flow">
            {activityFlow.map(item => (
              <li key={item.id} className="people-participant-flow-row">
                <span className="people-participant-flow-text">{item.text}</span>
                {item.time && (
                  <span className="people-participant-flow-time">{item.time}</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {rightSlot && (
        <div
          className="people-participant-right-slot"
          data-testid="teeup-detail-self-status-control"
          onClick={e => e.stopPropagation()}>
          {rightSlot}
        </div>
      )}
    </li>
  )
}

export default ParticipantItem
